<template>
    <el-form ref="form" label-width="120px" label-position="left" style="padding:0 20px;">
        <el-divider></el-divider>
        <el-form-item label="黑夜模式">
            <el-switch v-model="dark"></el-switch>
        </el-form-item>
        <el-divider></el-divider>
        <el-form-item label="主题颜色">
            <el-color-picker v-model="colorPrimary" :predefine="colorList">></el-color-picker>
        </el-form-item>
        <el-divider></el-divider>
        <el-form-item label="框架布局">
            <el-select v-model="layout" @change="layoutChange" placeholder="请选择">
                <el-option label="默认" value="default"></el-option>
                <el-option label="通栏" value="header"></el-option>
                <el-option label="经典" value="menu"></el-option>
                <el-option label="功能坞" value="dock"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="折叠菜单">
            <el-switch v-model="menuIsCollapse" @change="menuIsCollapseChange"></el-switch>
        </el-form-item>
        <el-form-item label="标签栏">
            <el-switch v-model="layoutTags" @change="layoutTagsChange"></el-switch>
        </el-form-item>
        <el-divider></el-divider>
    </el-form>
</template>

<script>
    import colorTool from '@/utils/color'
    import { getCurrentInstance, defineComponent, ref, watch, computed } from 'vue'
    import { useLayoutStore } from '@/store'
    import Cache from '@/utils/cache'

    export default defineComponent({
        setup(props, context) {
            const StoreLayout = useLayoutStore()
            const lang = ref(Cache.get('APP_LANG') || 'zh-cn')
            const dark = ref(Cache.get('APP_DARK') || false)
            const colorPrimary = ref(Cache.get('APP_COLOR') || '#409EFF')
            const colorList = ref(['#409EFF', '#009688', '#536dfe', '#ff5c93', '#c62f2f', '#fd726d'])
            const layout = computed(() => StoreLayout.layout)
            const layoutTags = computed(() => StoreLayout.layoutTags)
            const menuIsCollapse = computed(() => StoreLayout.menuIsCollapse)
            watch(
                () => dark.value,
                (val, oldv) => {
                    if (val) {
                        document.documentElement.classList.add('dark')
                        Cache.add('APP_DARK', val)
                    } else {
                        document.documentElement.classList.remove('dark')
                        Cache.del('APP_DARK')
                    }
                }
            )
            watch(
                () => colorPrimary.value,
                (val, oldv) => {
                    if (!val) {
                        val = '#409EFF'
                        colorPrimary.value = '#409EFF'
                    }
                    document.documentElement.style.setProperty('--el-color-primary', val)
                    for (let i = 1; i <= 9; i++) {
                        document.documentElement.style.setProperty(`--el-color-primary-light-${i}`, colorTool.lighten(val, i / 10))
                    }
                    for (let i = 1; i <= 9; i++) {
                        document.documentElement.style.setProperty(`--el-color-primary-dark-${i}`, colorTool.darken(val, i / 10))
                    }
                    Cache.add('APP_COLOR', val)
                }
            )
            const layoutChange = (e) => {
                Cache.add('layout', e)
                StoreLayout.layout = e
            }
            const menuIsCollapseChange = (e) => {
                Cache.add('menuIsCollapse', e)
                StoreLayout.menuIsCollapse = e
            }
            const layoutTagsChange = (e) => {
                Cache.add('layoutTags', e)
                StoreLayout.layoutTags = e
            }

            return {
                lang,
                dark,
                colorList,
                colorPrimary,

                layout,
                layoutTags,
                menuIsCollapse,
                layoutChange,
                menuIsCollapseChange,
                layoutTagsChange
            }
        }
    })
</script>

<style scoped>

</style>
